"use client";

import { SuccessIllustration } from "@/shared/components/dialogs/AlreadyAppliedDialog";

interface SuccessStepProps {
  jobTitle?: string;
  onDone: () => void;
}

export default function SuccessStep({
  jobTitle,
  onDone,
}: SuccessStepProps) {
  return (
    <div className="flex min-h-[320px] flex-col items-center justify-center px-6 py-8 text-center">
      
      {/* Animated Success Illustration */}
      <div className="flex h-[125px] w-[175px] items-center justify-center">
        <SuccessIllustration />
      </div>

      {/* Title */}
      <h2 className="mt-1 text-[18px] font-semibold leading-6 text-gray-900">
        Application Submitted
      </h2>

      {/* Message */}
      <p className="mx-auto mt-2 max-w-[300px] text-[12px] leading-[18px] text-gray-600">
        Your application for{" "}
        <span className="font-semibold text-gray-800">
          {jobTitle || "this job"}
        </span>{" "}
        has been submitted successfully. Our recruitment team will review
        your profile and contact you if your experience matches the role.
      </p>

      {/* Done */}
      <button
        type="button"
        onClick={onDone}
        className="
          mt-5
          inline-flex
          h-9
          min-w-[155px]
          items-center
          justify-center
          rounded-[5px]
          bg-[#3478F6]
          px-5
          text-[12px]
          font-medium
          text-white
          shadow-[0_3px_8px_rgba(52,120,246,0.25)]
          transition
          hover:bg-[#2868DE]
          focus:outline-none
          focus:ring-2
          focus:ring-[#3478F6]
          focus:ring-offset-2
        "
      >
        Done
      </button>
    </div>
  );
}